// extracted by mini-css-extract-plugin
export default {"trigger":"context-menu_trigger__SUP2A","menuItem":"context-menu_menuItem__wRPIs"};